module.exports = __webpack_public_path__ + "img/v-silver.e75bfdb0.png";